import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, MapPin, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-10 pb-8 md:pt-16 md:pb-12 px-4 overflow-hidden flex flex-col items-center text-center" data-id="element-166">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-167" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-168">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-dark-lighter border border-gold/30 text-gold-light text-xs font-semibold tracking-wider mb-3" data-id="element-169">
          <span data-id="element-170">⭐</span> ACADEMIA HOLÍSTICA ARGENTINA <span data-id="element-171">⭐</span>
        </div>

        <div className="mb-3 inline-block" data-id="element-172">
          <span className="bg-gold text-dark font-bold px-3 py-1 text-xs uppercase tracking-widest rounded-sm" data-id="element-173">
            MEGAPACK SISTEMA SOBERANO
          </span>
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading leading-tight mb-3 text-white" data-id="element-174">
          Reprogramá tu mente.{' '}
          <span className="text-gold-light" data-id="element-175">Recuperá el control.</span>{' '}
          Transformá tu vida en el contexto argentino.
        </h1>

        <p className="text-base md:text-lg text-gray-300 mb-4 max-w-2xl mx-auto" data-id="element-176">
          PNL Aplicada — 6 Tomos + 6 Bonos
        </p>

        <motion.img src="https://cdn.magicpatterns.com/uploads/9MCkE3nCJCxxDtcdp7wFGX/ChatGPT_Image_29_abr_2026,_10_05_19.png" alt="MegaPack Sistema Soberano — 6 Tomos + 6 Bonos de PNL Aplicada" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="w-full max-w-md md:max-w-lg mx-auto mb-4 rounded-lg drop-shadow-[0_0_40px_rgba(212,168,67,0.2)]" data-id="element-177" />

        <div className="flex flex-wrap justify-center gap-4 mb-4 text-xs md:text-sm text-gray-300 font-medium" data-id="element-178">
          <div className="flex items-center gap-1.5" data-id="element-179">
            <FileText className="w-4 h-4 text-gold" data-id="element-180" />
            <span data-id="element-181">100% PDF</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-182">
            <Zap className="w-4 h-4 text-gold" data-id="element-183" />
            <span data-id="element-184">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-185">
            <MapPin className="w-4 h-4 text-gold" data-id="element-186" />
            <span data-id="element-187">Hecho para Argentina</span>
          </div>
        </div>

        <motion.a href="#pricing" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-base md:text-lg rounded-lg shadow-[0_0_30px_rgba(212,168,67,0.3)] hover:shadow-[0_0_40px_rgba(212,168,67,0.5)] transition-all animate-pulse-slow mb-3" data-id="element-188">
          → QUIERO MI MEGAPACK AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-xs text-gray-400" data-id="element-189">
          <div className="flex items-center gap-1.5" data-id="element-190">
            <Shield className="w-3.5 h-3.5" data-id="element-191" />
            <span data-id="element-192">Garantía 7 días</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-193">|</span>
          <div className="flex items-center gap-1.5" data-id="element-194">
            <Lock className="w-3.5 h-3.5" data-id="element-195" />
            <span data-id="element-196">Pago seguro</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-197">|</span>
          <div className="flex items-center gap-1.5" data-id="element-198">
            <CreditCard className="w-3.5 h-3.5" data-id="element-199" />
            <span data-id="element-200">Mercado Pago</span>
          </div>
        </div>
      </motion.div>
    </section>;
}